// Utilities for exporting student directory and other table views to CSV format

/**
 * Downloads a CSV file with the given content
 */
export function downloadCSV(csvContent, filename) {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.setAttribute("href", url);
  link.setAttribute("download", `${filename}_${new Date().toISOString().slice(0, 10)}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

/**
 * Exports a generic grid array to CSV
 */
export function exportGridToCSV(headers, rows, filename) {
  let csvContent = headers.join(",") + "\n";

  rows.forEach(row => {
    const rowData = row.map(cell => {
      const text = String(cell || '').replace(/,/g, "").replace(/\n/g, " ");
      return `"${text}"`;
    });
    csvContent += rowData.join(",") + "\n";
  });

  downloadCSV(csvContent, filename);
}

/**
 * Exports a student list to CSV
 */
export function exportStudentsToCSV(students, filename = 'Student_Directory') {
  const headers = [
    'Student ID',
    'Student Name',
    'Registered Grade',
    'Section',
    'School/Branch',
    'English Mastery',
    'Math Mastery',
    'Participation Status'
  ];

  const rows = students.map(s => [
    s.id,
    s.name,
    `Grade ${s.registeredGrade}`,
    s.section || 'N/A',
    s.school,
    s.participated ? s.englishMastery : 'N/A',
    s.participated ? s.mathMastery : 'N/A',
    s.status
  ]);
  exportGridToCSV(headers, rows, filename);
}
